import reportAnalysisTypes from './types/reportAnalysis'
import reportAnalysisService from '@/api/reportAnalysis'

const state = {}

const actions = {
  /**
   * 获取分区雨量列表
   */
  [reportAnalysisTypes.GET_AREA_RAINFALL_RAIN] ({ commit }, { sID = '22', addvcd = '', beginTime = '', endTime = '' }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.getAreaRainfall({ sID, addvcd, beginTime, endTime }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出区雨量列表
   */
  [reportAnalysisTypes.EXPORT_AREA_RAINFALL_RAIN] ({ commit }, { sID = '22', beginTime = '', endTime = '' }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.exportAreaRainfall({ sID, beginTime, endTime }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取水库动态蓄水列表
   */
  [reportAnalysisTypes.GET_DYNAMIC_RESERVOIR_STORAGE] ({ commit }, { sID = '22', Time = '', ReservoirScale = '', Type = '' }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.getDynamicResevoirStorage({ sID, Time, ReservoirScale, Type }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出水库动态蓄水列表
   */
  [reportAnalysisTypes.EXPORT_DYNAMIC_RESERVOIR_STORAGE] ({ commit }, { Time = '', ReservoirScale = '', Type = '' }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.exportDynamicResevoirStorage({ Time, ReservoirScale, Type }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 到站率统计
   */
  [reportAnalysisTypes.STATION_ARRIVE_RATE] ({ commit }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.stationArriveRate().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水雨情简报
   */
  [reportAnalysisTypes.WATER_RAIN_BRIEFING] ({ commit }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.rainWaterBriefing().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水雨情日报
   */
  [reportAnalysisTypes.WATER_RAIN_DAILY] ({ commit }, { begTime = '', endTime = '' }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.rainWaterDaily({ begTime, endTime }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水情快报
   */
  [reportAnalysisTypes.WATER_NEWS] ({ commit }, { time = '' }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.waterNews({ time }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 雨水情告知单模板
   */
  [reportAnalysisTypes.GET_RAIN_WATER_NOTICE_TEMPLATE] ({ commit }, { time = '' }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.rainWaterNoticeTemplate({ time }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取雨水情告知单列表
   */
  [reportAnalysisTypes.GET_LIST_RAIN_WATER_NOTICE] ({ commit }, { begTime = '', endTime = '' }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.getListRainWaterNotice({ begTime, endTime }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
     * 保存雨水情告知单
     */
  [reportAnalysisTypes.SAVE_RAIN_WATER_NOTICE] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.saveRainWaterNotice(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
     * 删除雨水情告知单
     */
  [reportAnalysisTypes.DELETE_RAIN_WATER_NOTICE] (_, { id }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.delRainWaterNotice(id).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 获取已经预警时间列表
   */
  [reportAnalysisTypes.GET_LIST_WARN_RECORD_TIME] ({ commit }) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.getListWarnRecordTime().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 异常数据报表
   */
  [reportAnalysisTypes.GET_ABNORMAL_VAVAL] ({ commit }, { Type = '' }) { // 获取异常值
    return new Promise((resolve, reject) => {
      reportAnalysisService.getAbnormalValue({ Type }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [reportAnalysisTypes.SAVE_GET_ABNORMAL_DATA] ({ commit }, params) { // 保存设置的异常值
    return new Promise((resolve, reject) => {
      reportAnalysisService.saveAbnormalValue(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [reportAnalysisTypes.GET_ABNORMAL_DATA] ({ commit }, { Type = '', BeginTime = '', EndTime = '' }) { // 获取异常值
    return new Promise((resolve, reject) => {
      reportAnalysisService.getAbnormalData({ Type, BeginTime, EndTime }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出缺报数据
   */
  [reportAnalysisTypes.EXPORT_PROBLEM_STATION] ({ commit }, stationGroup) {
    return new Promise((resolve, reject) => {
      reportAnalysisService.exportProblemStation(stationGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
